if (!customElements.get('ibbc-cart-recommendations')) {
  customElements.define(
    'ibbc-cart-recommendations',
    class IbbcCartRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loading === 'true' || !this.dataset.url) return;
        this.dataset.loading = 'true';

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.ibbc-cart-recommendations');
            const items = recommendations?.querySelectorAll('.ibbc-cart-recommendations__item');

            if (recommendations && items?.length) {
              this.innerHTML = recommendations.outerHTML;
              this.hidden = false;
            } else {
              this.remove();
            }
          })
          .catch(() => this.remove());
      }
    }
  );
}
